module.exports = __webpack_public_path__ + "static/media/apps-active2.025cb1c3.svg";